/**
 * Клас невалідної комірки таблиці завдань: TaskTable ставить його через `onCell`, коли поле
 * завдання не пройшло перевірку перед «Транспорт розподілено» (стиль — у RequestFormTemplate.module.css).
 */
export const INVALID_CELL_CLASS = 'task-cell-invalid'
